import {ref, computed} from 'vue'
import {useRoute} from 'vue-router'
import {getReportInspectionOverseas} from '@api'

// reportInspectionOverseas
// - 2026.03.26
const reportInspectionOverseas = ref(null)

// findBodyPanel
// - Find a body panel item by name from body_inspection_summary
function findBodyPanel (name) {
  return computed(() => {
    const items = reportInspectionOverseas.value
      && reportInspectionOverseas.value.body_inspection_summary

    if (!items || !items.length) return null

    return items.find(item => item.name === name) || null
  })
}

// bumper
// - 2026.04.07
const bumper = computed(() => {
  return reportInspectionOverseas.value && reportInspectionOverseas.value.bumper
})

// useReportInspectionOverseas
// - 2026.03.26
export function useReportInspectionOverseas () {
  return {
    reportInspectionOverseas,
    loadReportInspectionOverseas,
    bumper,
    diagramPointHood: findBodyPanel('hood'),
    diagramPointFenderFrontRight: findBodyPanel('right_front_fender'),
    diagramPointDoorFrontRight: findBodyPanel('right_front_door'),
    diagramPointDoorRearRight: findBodyPanel('right_rear_door'),
    diagramPointFenderRearRight: findBodyPanel('right_rear_quarter_panel'),
    diagramPointTrunk: findBodyPanel('tailgate'),
    diagramPointFenderRearLeft: findBodyPanel('left_rear_quarter_panel'),
    diagramPointDoorRearLeft: findBodyPanel('left_rear_door'),
    diagramPointDoorFrontLeft: findBodyPanel('left_front_door'),
    diagramPointFenderFrontLeft: findBodyPanel('left_front_fender'),
    diagramPointRoof: findBodyPanel('roof'),
  }
}

// loadReportInspectionOverseas
// - 2026.03.26
async function loadReportInspectionOverseas () {
  try {
    const route = useRoute()
    const moduleId = route.params.id
    const business = route.params.business

    const rb = await getReportInspectionOverseas({
      params: {
        module_id: moduleId,
        business,
        ...route.query,
      },
    })

    reportInspectionOverseas.value = rb
  }
  catch (err) {
    alert(err.message || err || JSON.stringify(err))
  }
}
